import {
  SET_ORGANIZATION,
  UPDATE_ORGANIZATION,
} from '../actions/types';

const defaultState = {
  id: '',
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_ORGANIZATION:
      return action.payload;
    case UPDATE_ORGANIZATION:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
